class GPSProviderTelematicPropCollection extends App.Collections.BaseCollection {
    url = 'GPSProviderTelematicProp';
    model = App.Models.GPSProviderTelematicProp;
}

App.Collections.GPSProviderTelematicProps = GPSProviderTelematicPropCollection;